import React, { useEffect, useState, useRef } from 'react';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';

import { useParams } from "react-router-dom";
import { useLocation, Link } from 'react-router-dom';

import { DateFormatter } from "../../utils/DateFormatter";
import { set } from 'd3v4';

function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

  }

export default function ConfigKey() {
    let { id } = useParams();
    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));
    const [loading, setLoading] = useState(true);

    const [value, setValue] = useState('');
    const [displayValue, setDisplayValue] = useState('');
    const [checked, setChecked] = useState(false);
    const [order, setOrder] = useState('');
    const [default_value, setDefault_value] = useState('');
    const [postData, setPostData] = useState(false);

    const [startVal, setStartVal] = useState('');
    const [stopVal, setStopVal] = useState('');
    const [stepVal, setStepVal] = useState('');

    const [data, setData] = useState({ id: 0, key: "Loading", definitionId: "Loading", displaykey: "Loading", order: "Loading", createdAt: "Loading", updatedAt: "Loading" });
    // const [configValueData, setConfigValueData] = useState({ id: 0, ConfigKeyId: "Loading", value: "Loading", DisplayValue: "Loading", createdAt: "Loading", updatedAt: "Loading" });
    const [configValueData, setConfigValueData] = useState({});

    // Toast and ConfirmDialog
    const toast = useRef(null);

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getDataUserToken}`,
    };

    const dateTemplate = (configkey) => {
        return DateFormatter(configkey.createdAt);
    }

    const dateTemplateUpdate = (configkey) => {
        return DateFormatter(configkey.updatedAt);
    }

    const configkeyBodyTemplate = (configValue) => {
        return (
            <div>
                <Link to={`/workflows/configvalue/${configValue.id}`} className="ml-2">{configValue.id}</Link>
            </div>
        );
    };

    const tableFooter = `There are ${configValueData.length} ConfigValues.`;

    const [userDetails, setUserDetails] = useState(             // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('userDetails', null)
    );

    const canView = (userDetails) => {
        if (userDetails) {
            return userDetails.permissions.some(e => e.codename === 'view_workflowconfigmanagement');
        }
        return false;
    }

    useEffect(() => {
        document.title = `ConfigKey | Palmona Pathogenomics`
    }, []);

    useEffect(() => {
        // Get the ConfigKey details
        fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/configkey/${id}`, {
            headers,
            }).then((res) => res.json())
            .then(data => {
                setData(data);
            // })
            // .then(() => {
                if (data.value_type === 'BOOLEAN') {
                    // If it's a boolean, we need to set the value to true or false
                    // Get the ConfigValue for the ConfigKey
                    if (data.ConfigValues?.length && data.ConfigValues[0].value === 'true') {
                        setChecked(true);
                    } else {
                        setChecked(false);
                    }
                }

                if (data.value_type === 'INTEGER_RANGE') {
                    // To Do: Implement Integer Range
                    // Get the ConfigValue for the ConfigKey
                    if (data.ConfigValues?.length) {
                        const my_value = JSON.parse(data.ConfigValues[0].value);
                        setStartVal(my_value.startVal);
                        setStopVal(my_value.stopVal);
                        setStepVal(my_value.stepVal);
                    }

                }
            })
            .catch((error) => {
                console.log('Error in getting ConfigKeys', error);
            });        

        setLoading(false);
    }, [])  // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/configvalue/getbykey/${id}`, {
            headers,
            }).then((res) => res.json())
            .then(value_data => {
                setConfigValueData(value_data);
            // }).then(() => {

                // console.log('value_data', value_data);
                // console.log('data', data);

                if (data.value_type === 'BOOLEAN') {
                    if (value_data.length > 0 && value_data[0].value === 'true') {
                        setChecked(true);
                    } else {
                        setChecked(false);
                    }
                }

                if (data.value_type === 'INTEGER_RANGE') {
                    if (value_data?.length > 0) {
                        const my_value = JSON.parse(value_data[0].value);
                        setStartVal(my_value.startVal);
                        setStopVal(my_value.stopVal);
                        setStepVal(my_value.stepVal);
                    }
                }


            })
            .catch((error) => {
                console.log('Error in getting ConfigValues for the ConfigKey.', error);
            });
    }, [postData]);

    useEffect(() => {

        let my_value = '';
        let my_displayValue = '';
        
        if (postData) {

            if (data.value_type === 'BOOLEAN') {
                // If it's a boolean, we need to set the value to true or false
                // But we can only have one value, so we need to update the value if it exists.

                if (checked === true) {
                    my_value = 'true';
                    my_displayValue = 'true';
                } else {
                     my_value ='false';
                    my_displayValue = 'false';
                }

                if (configValueData.length > 0) {
                    // We need to update the value
                    fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/configvalue/${configValueData[0].id}`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${getDataUserToken}`,
                        },
                        body: JSON.stringify({
                            value: my_value,
                            DisplayValue: my_displayValue,
                        })
                    }).then((res) => res.json())
                    .then(data => {
                        if (data.error) {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: data.error });
                        } else {
                            toast.current.show({ severity: 'success', summary: 'Success', detail: 'ConfigValue updated successfully.' });
                            setChecked(false);
                            setPostData(false);
                        }
                    })
                    .catch((error) => {
                        console.log('Error in updating ConfigValue', error);
                    });

                    return;
                } else {
                    // We need to create the value
                    fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/configvalue`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${getDataUserToken}`,
                        },
                        body: JSON.stringify({
                            configkeyId: id,
                            value: my_value,
                            DisplayValue: my_displayValue,
                            default_value: true,
                        })
                    }).then((res) => res.json())
                    .then(data => {
                        if (data.error) {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: data.error });
                        } else {
                            toast.current.show({ severity: 'success', summary: 'Success', detail: 'ConfigValue added successfully.' });
                            setChecked(false);
                            setPostData(false);
                        }
                    }
                    ).catch((error) => {
                        console.log('Error in adding ConfigValue', error);
                    });
                }


            } else if (data.value_type === 'INTEGER_RANGE') {
                // To Do: Implement Integer Range

                // console.log('Integer Range Value:', value);
                // console.log('Display Value:', displayValue);

                // console.log('Start Value:', startVal);
                // console.log('Stop Value:', stopVal);
                // console.log('Step Value:', stepVal);

                // We need to create the value
                const my_value = { startVal: startVal, stopVal: stopVal, stepVal: stepVal };

                const myJSON = JSON.stringify(my_value);

                // If it's an INTEGER RANGE, we need to set the value to myJSON
                // But we can only have one value, so we need to update the value if it exists.

                // console.log('configValueData', configValueData);

                if (configValueData.length > 0) {
                    // We need to update the value
                    fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/configvalue/${configValueData[0].id}`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${getDataUserToken}`,
                        },
                        body: JSON.stringify({
                            value: myJSON,
                            DisplayValue: myJSON,
                            default_value: true,
                        })
                    }).then((res) => res.json())
                    .then(data => {
                        if (data.error) {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: data.error });
                        } else {
                            toast.current.show({ severity: 'success', summary: 'Success', detail: 'ConfigValue updated successfully.' });
                            setStartVal('');
                            setStopVal('');
                            setStepVal('');
                            setPostData(false);
                        }
                    })
                    .catch((error) => {
                        console.log('Error in updating ConfigValue', error);
                    });

                    return;
                } else {

                    fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/configvalue`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${getDataUserToken}`,
                        },
                        body: JSON.stringify({
                            configkeyId: id,
                            value: myJSON,
                            DisplayValue: myJSON,
                        })
                    }).then((res) => res.json())
                    .then(data => {
                        if (data.error) {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: data.error });
                        } else {
                            toast.current.show({ severity: 'success', summary: 'Success', detail: 'ConfigValue added successfully.' });
                            setStartVal('');
                            setStopVal('');
                            setStepVal('');
                            setPostData(false);
                        }
                    }
                    ).catch((error) => {
                        console.log('Error in adding ConfigValue', error);
                    });
                }

            } else {
                // It's a single or multi-choice
                // We need to create the value
                my_value = value;
                my_displayValue = displayValue;

                fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/configvalue`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${getDataUserToken}`,
                    },
                    body: JSON.stringify({
                        configkeyId: id,
                        value: my_value,
                        DisplayValue: my_displayValue,
                        default_value: default_value,
                    })
                }).then((res) => res.json())
                .then(data => {
                    if (data.error) {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: data.error });
                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: 'ConfigValue added successfully.' });
                        setValue('');
                        setDisplayValue('');
                        setOrder('');
                        setDefault_value('');
                        setPostData(false);
                    }
                }
                ).catch((error) => {
                    console.log('Error in adding ConfigValue', error);
                });
            }
        }
    }, [postData]);  // eslint-disable-line react-hooks/exhaustive-deps

    return (

        <>
        { canView(userDetails) && 
            <div className="surface-card p-4 shadow-2 border-round">
            <Toast ref={toast} />
            <ConfirmDialog group="templating" />
            <div className="font-medium text-3xl text-900 mb-3">ConfigKey Details</div>
      
            <ul className="list-none p-0 m-0">
                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">ID</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.id}</div>
                </li>

                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">DefinitionId</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.definitionId}</div>
                </li>

                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">Key</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.key}</div>
                </li>

                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">Display Key</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.DisplayKey}</div>
                </li>

                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">Order</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.order}</div>
                </li>

                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">Value Type</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.value_type}</div>
                </li>

                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">Ceated At</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{dateTemplate(data)}</div>
                </li>
                
                <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">Last Updated</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{dateTemplateUpdate(data)}</div>
                </li>


                { (data.value_type === 'SINGLE_CHOICE' || data.value_type === 'MULTI_CHOICE') && 
                    <li className="flex align-items-center py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">

                        <div className="text-500 w-6 md:w-2 font-medium">ConfigValues</div>
                        <div className="card">  
                            <DataTable 
                                value={configValueData} 
                                emptyMessage="ConfigKey currently has no ConfigValues." 
                                tableStyle={{ minWidth: '50rem' }}
                                footer={tableFooter}
                            >
                                <Column field="id" header="ID" body={configkeyBodyTemplate}></Column>
                                <Column field="ConfigKeyId" header="ConfigKeyId"></Column>
                                <Column field="value" header="Value"></Column>
                                <Column field="DisplayValue" header="Display Value"></Column>
                                <Column field="default_value" header="Default Value"></Column>
                                <Column field="createdAt" header="Creation Date"></Column>
                            </DataTable>

                            <div>
                                <div className="text-900 font-medium text-xl m-3">Add ConfigValue</div>
                                <p className="m-0 p-0 text-600 line-height-3 m-3">ConfigValues provide configuration information added to the Workflow Definition at execution.</p>
                                <div className="grid formgrid p-fluid">
                                    <div className="field m-4 col-6">
                                        <label htmlFor="key1" className="font-medium text-900">Value</label>
                                        <InputText id="key1" type="text" value={value} onChange={(e) => setValue(e.target.value)} />
                                    </div>
                                    <div className="field m-4 col-6 md:col-6">
                                        <label htmlFor="displaykey1" className="font-medium text-900">Display Value</label>
                                        <InputText id="displaykey1" type="text" value={displayValue} onChange={(e) => setDisplayValue(e.target.value)}/>
                                    </div>
                                    <div className="field m-4 col-6 md:col-6">
                                        <label htmlFor="order1" className="font-medium text-900">Default Value</label>
                                        <Checkbox onChange={e => setDefault_value(e.checked)} checked={default_value}></Checkbox>
                                    </div>
                                    <div className="field m-4 col-6 md:col-6">
                                        <label htmlFor="order1" className="font-medium text-900">Display Order</label>
                                        <InputText id="order1" type="text" value={order} onChange={(e) => setOrder(e.target.value)}/>
                                    </div>
                                    <div className="col-6 m-4">
                                        <Button label="Create ConfigValue" className="w-auto mt-3" onClick={() =>  setPostData(true) }/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                }

                { data.value_type === 'BOOLEAN' && 
                    <li className="flex align-items-center py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
                        <div className="text-500 w-6 md:w-2 font-medium">ConfigValues</div>
                        <div className="card m-2">
                        <label htmlFor="key1" className="font-medium text-900 m-2">Default TRUE?</label>
                            <Checkbox className="m-2" onChange={e => setChecked(e.checked)} checked={checked}></Checkbox>
                        </div>
                        <div className="col-6 m-4">
                            <Button label="Set Boolean" className="w-auto mt-3" onClick={() =>  setPostData(true) }/>
                        </div>
                    </li>
                }

                { data.value_type === 'INTEGER_RANGE' && 
                    <li className="flex align-items-center py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
                        <div className="text-500 w-6 md:w-2 font-medium">ConfigValues</div>
                        <div className="card">
                            <p>Create an INTEGER_RANGE</p>

                            <div className="field mb-4 col-12">

                                <div className="card flex align-items-center md:flex-row gap-3 flex-wrap align-content-center justify-content-center">
                                
                                    <div className="p-inputgroup flex-1 w-3 ">
                                        <span className="p-inputgroup-addon">
                                            {/* <i className="pi pi-play"></i> */}
                                            Start
                                        </span>
                                        <InputText id={'start1'} type="number" value={startVal} onChange={(e) => {setStartVal(e.target.value)}}
                                            placeholder="Start"
                                            style={{ width: '50%' }}
                                        />
                                    </div>

                                    <div className="p-inputgroup flex-1 w-3">
                                        <span className="p-inputgroup-addon">
                                            {/* <i className="pi pi-stop"></i> */}
                                            Stop
                                        </span>
                                        <InputText id={'stop1'} type="number" value={stopVal} onChange={(e) => {setStopVal(e.target.value)}} 
                                            placeholder="Stop"
                                            style={{ width: '50%' }}
                                        />
                                    </div>

                                    <div className="p-inputgroup flex-1 w-3">
                                        <span className="p-inputgroup-addon">
                                            {/* <i className="pi pi-step-forward"></i> */}
                                            Step
                                        </span>
                                        <InputText id={'step1'} type="number" value={stepVal} onChange={(e) => {setStepVal(e.target.value)}} 
                                            placeholder="Step"
                                            style={{ width: '50%' }}
                                        />
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div className="col-6 m-4">
                            <Button label="Set Integer Range" className="w-auto mt-3" onClick={() =>  setPostData(true) }/>
                        </div>
                    </li>
                }
            </ul>
            </div>
        }

        { !canView(userDetails) && <div className="font-medium text-3xl text-900 mb-3">You do not have permission to view this page.</div> }
        </>
    );
}
